<span class="spinner-border" style="--bs-spinner-width: 3rem; --bs-spinner-height: 3rem"></span>
@for (message of messages; track message) {
  <p class="spinner-message">{{ message }}</p>
}
